import { Component, Input, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as fileSaver from 'file-saver';
import * as moment from 'moment';
import { ConversaoLibraConverte } from './../../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';
import { AnalisePassagemBi03Service } from './analise-passagem-bi03.service';
import { BiRelatorioAnaliseService } from '../bi-relatorio-analise/bi-relatorio-analise.service';
import { ServiceAppService } from '../../../../security/service-app.service';

declare var $: any;

@Component({
  selector: 'app-analise-passagem-bi03',
  templateUrl: './analise-passagem-bi03.component.html',
  styleUrls: ['./analise-passagem-bi03.component.css']
})
export class AnalisePassagemBi03Component implements OnInit {
  subscription;
  nomeModulo: string;
  dados: any
  dealers: string[]
  regioes: string[]
  mercados: string[]
  gruposEconomicos: string[]
  display: boolean = false;
  value: Date;
  carregando: boolean = false
  anos: any[];
  meses: any[]
  isExportOneVoice: boolean = false;
  isExportPassagens: boolean = false;
  isExportPassagensDetalhado: boolean = false;
  isFilterTable: boolean = false
  lastYearGrid: any
  marcas: any;
  
  @Input() data: any;
  @Input() definirAno: boolean = true;
  @Input() filtros = {
    ano: '',
    mes_inicial: '',
    mes_final: '',
    mercado: '',
    grupo_economico: '',
    regiao: '',
    dealer: '',
    part_number: ''
  };

  data_inicial: any;
  data_final: any;

  analisePassagemTranslate = {
    "Passagens Garantia": "rmpv.analisePassagem.passagemGarantia",
    "Passagens Recall": "rmpv.analisePassagem.passagemRecall",
    "Passagens Seguros/Franquias": "rmpv.analisePassagem.passagemSeguro",
    "Passagens Revisões": "rmpv.analisePassagem.passagemRevisao",
    "Passagens Cliente": "rmpv.analisePassagem.passagemCliente",
    "Passagens Acessórios": "rmpv.analisePassagem.passagemAcessorios",
    "Passagens Serviços Internos": "rmpv.analisePassagem.passagemServicoInterno",
    "Passagens PDI": "rmpv.analisePassagem.passagemPDI",
    "Total de Passagens": "rmpv.analisePassagem.totalPassagens",
    "Passagens agendadas": "rmpv.analisePassagem.passagemAgendada",
    "% Agendamento": "rmpv.analisePassagem.%Agendamento",
    "Passagens agendadas de forma ativa": "rmpv.analisePassagem.passagemAgendadaAtiva",
    "% Agendamento Ativo": "rmpv.analisePassagem.%AgendamentoAtivo",
    "OS em aberto > 30 dias - Garantia": "rmpv.analisePassagem.passagemMaiorGarantia",
    "OS em aberto > 30 dias - Outros": "rmpv.analisePassagem.passagemMaiorOutros",
    "OS em aberto > 30 dias - R$": "rmpv.analisePassagem.passagemMaiorValor",
    "Quantidade Boxes": "rmpv.analisePassagem.quantidadeBoxes",
    "Janeiro": "rmpv.analisePassagem.filtros.meses.janeiro"
  };

  constructor(
    private service: AnalisePassagemBi03Service,
    private serviceMarca: ServiceAppService,
    private exportExcelService: ExportExcelService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private translate: TranslateService,) {
    this.nomeModulo = 'analise-passagem-bi03';
  }

  ngOnInit() {
    this.serviceMarca.getDados(`/admin/capturarMarca`).subscribe(res => {
      const marca = res.nome;
      if (marca.includes("VOLVO") || marca.includes("NBS")) {
        this.marcas = "Volvo";
      } else if (marca.includes("GWM")) {
        this.marcas = "GWM";
      } else if (marca.includes("GAC")) {
        this.marcas = "GAC";
      }
    });

    if (this.definirAno) {
      this.handleDate();
    }
    this.getAll();

    this.preencherMercados();
    this.preencherGruposEconomicos();
    this.preencherRegioes()
    this.preencherDealers();
    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.getAll();
      });
    //fimConversaolibra
  }
  // get f() { return this.form.controls; }

  handleDate() {
    let currentYear = new Date();

    let year = currentYear.getFullYear();
    let lastYear = currentYear.getFullYear() - 1;
    let belatedYear = currentYear.getFullYear() - 2;

    this.filtros.ano = year.toString();
    this.filtros.mes_inicial = '1';
    this.filtros.mes_final = '12';

    this.data_inicial = new Date();
    this.data_final = new Date();

    this.anos = [
      { field: year.toString() },
      { field: lastYear.toString() },
      { field: belatedYear.toString() }
    ];

    this.meses = [
      { field: '1', header: 'Janeiro' },
      { field: '2', header: 'Fevereiro' },
      { field: '3', header: 'Março' },
      { field: '4', header: 'Abril' },
      { field: '5', header: 'Maio' },
      { field: '6', header: 'Junho' },
      { field: '7', header: 'Julho' },
      { field: '8', header: 'Agosto' },
      { field: '9', header: 'Setembro' },
      { field: '10', header: 'Outubro' },
      { field: '1', header: 'Novembro' },
      { field: '12', header: 'Dezembro' },
    ];
  }

  getTranslate(value) {
    return this.analisePassagemTranslate[value];

  }
  getAll() {
    this.lastYearGrid = this.filtros.ano;
    this.carregando = true;
    this.service.getAllPaginate(this.filtros.ano, this.filtros.mes_inicial, this.filtros.mes_final, this.filtros.mercado, this.filtros.grupo_economico, this.filtros.regiao, this.filtros.dealer).subscribe(res => {
      this.dados = res;

      let registro = res.os_aberto.linhas[2];

      registro.mes_01 = this.conversaoLibraConverte.conversaoLibra(registro.mes_01, null, null);
      registro.mes_02 = this.conversaoLibraConverte.conversaoLibra(registro.mes_02, null, null);
      registro.mes_03 = this.conversaoLibraConverte.conversaoLibra(registro.mes_03, null, null);
      registro.mes_04 = this.conversaoLibraConverte.conversaoLibra(registro.mes_04, null, null);
      registro.mes_05 = this.conversaoLibraConverte.conversaoLibra(registro.mes_05, null, null);
      registro.mes_06 = this.conversaoLibraConverte.conversaoLibra(registro.mes_06, null, null);
      registro.mes_07 = this.conversaoLibraConverte.conversaoLibra(registro.mes_07, null, null);
      registro.mes_08 = this.conversaoLibraConverte.conversaoLibra(registro.mes_08, null, null);
      registro.mes_10 = this.conversaoLibraConverte.conversaoLibra(registro.mes_10, null, null);
      registro.mes_11 = this.conversaoLibraConverte.conversaoLibra(registro.mes_11, null, null);
      registro.mes_12 = this.conversaoLibraConverte.conversaoLibra(registro.mes_12, null, null);
      registro.total_ano = this.conversaoLibraConverte.conversaoLibra(registro.total_ano, null, null);
      registro.total_ano_anterior = this.conversaoLibraConverte.conversaoLibra(registro.total_ano_anterior, null, null);
      registro.total_ano_retrasado = this.conversaoLibraConverte.conversaoLibra(registro.total_ano_retrasado, null, null);
      
      this.carregando = false
    });
    this.display = false
  }

  //Filters
  cleanFilter() {
    this.filtros.mercado = '';
    this.filtros.regiao = '';
    this.filtros.grupo_economico = '';
    this.filtros.dealer = '';
    this.filtros.part_number = '';

    this.handleDate()
  }

  showDialog() {
    this.display = true;
    this.isFilterTable = true;
    this.isExportPassagens = false;
    this.isExportPassagensDetalhado = false;
    this.isExportOneVoice = false;
  }

  showDialogExport() {
    this.display = true;
    this.isExportPassagens = true;
    this.isExportPassagensDetalhado = false;
    this.isFilterTable = false;
    this.isExportOneVoice = false;
  }

  showDialogExportDetalhado() {
    this.display = true;
    this.isExportPassagensDetalhado = true;
    this.isExportPassagens = false;
    this.isFilterTable = false;
    this.isExportOneVoice = false;
  }

  showDialogExportOneVoiceCsv() {
    this.display = true;
    this.isExportOneVoice = true;
    this.isFilterTable = false;
    this.isExportPassagens = false;
    this.isExportPassagensDetalhado = false;
  }


  preencherMercados() {
    this.service.buscarFiltros('mercado')
      .subscribe(r => { this.mercados = r.filtros; });
  }

  preencherGruposEconomicos() {
    this.service.buscarFiltros('grupo_economico')
      .subscribe(r => { this.gruposEconomicos = r.filtros; });
  }

  preencherRegioes() {
    this.service.buscarFiltros('regiao')
      .subscribe(r => { this.regioes = r.filtros; });
  }

  preencherDealers() {

    if (this.filtros.grupo_economico !== '') {
      this.service.buscarFiltros(`${'dealerGrupo/' + this.filtros.grupo_economico}`)
        .subscribe(r => { this.dealers = r.filtros; });
    } else {
      this.service.buscarFiltros('dealer')
        .subscribe(r => { this.dealers = r.filtros; });
    }
  }

  exportarExcel() {
    this.carregando = true
    this.exportExcelService.nomeModulo = this.nomeModulo;
    this.exportExcelService.ExportTOExcel();
    this.carregando = false
  }

exportPassagensCsv(): void {
  let start = moment(this.data_inicial).format("YYYY-MM-DD");
  let end = moment(this.data_final).format("YYYY-MM-DD");

  this.carregando = true;
  this.service.downloadCsvPassagens(start, end, this.filtros.part_number, this.filtros.dealer, this.filtros.regiao, this.filtros.grupo_economico, this.filtros.mercado)
    .subscribe(res => {
      this.salvarCsvPassagens(res, 'passagens_');
    }, error => console.log('Error downloading the file -> ', error));

  this.display = false;
}

exportPassagensDetalhadoCsv(): void {
  let start = moment(this.data_inicial).format("YYYY-MM-DD");
  let end = moment(this.data_final).format("YYYY-MM-DD");

  this.carregando = true;
  this.service.downloadCsvPassagensDetalhado(start, end, this.filtros.part_number, this.filtros.dealer, this.filtros.regiao, this.filtros.grupo_economico, this.filtros.mercado)
    .subscribe(res => {
      this.salvarCsvPassagens(res, 'passagens_detalhado_');
    }, error => console.log('Error downloading the file -> ', error));

  this.display = false;
}

salvarCsvPassagens(res: string, prefixoArquivo: string): void {
  const delimitador = res.includes(';') ? ';' : ',';

  // Renomeia apenas no cabecalho e por campo exato, para nao afetar as
  // colunas novas (PRICE_SERVICE_CODE, PART_CODE, etc.) nem valores de dados.
  const renomearHeader: { [key: string]: string } = {
    CODIGO_SERVICO: 'SERVICE_CODE',
    CODIGO_PECA: 'PART_CODE',
    DESCRICAO_PECA: 'PART_DESCRIPTION',
  };

  // Colunas que devem sair como numero somavel e como data DD/MM/AAAA.
  const colunasMonetarias = [
    'PRICE_SERVICE_CODE',
    'VALUE_PUBLIC_PRICE',
    'DISCOUNT_SERVICE_CODE',
    'PRICE_PART_CODE',
    'DISCOUNT_PART_CODE',
  ];
  const colunasData = ['DATE_INVOICE_SERVICE_CODE', 'DATE_INVOICE_PART_CODE'];
  const colunasNotaFiscal = ['INVOICE_SERVICE_CODE', 'INVOICE_PART_CODE'];

  // Com delimitador ';' usamos virgula decimal para o Excel pt-BR somar.
  const usarVirgulaDecimal = delimitador === ';';

  const indicesMonetarios: number[] = [];
  const indicesData: number[] = [];
  const indicesNotaFiscal: number[] = [];

  const csvLimpo = res
    .split(/\r?\n/)
    .map((linha, indice) => {
      const campos = linha.split(delimitador).map(campo => campo.trim());

      if (indice === 0) {
        campos.forEach((campo, i) => {
          const nome = campo.toUpperCase();
          if (colunasMonetarias.indexOf(nome) !== -1) { indicesMonetarios.push(i); }
          if (colunasData.indexOf(nome) !== -1) { indicesData.push(i); }
          if (colunasNotaFiscal.indexOf(nome) !== -1) { indicesNotaFiscal.push(i); }
        });
        return campos
          .map(campo => renomearHeader[campo.toUpperCase()] || campo)
          .join(delimitador);
      }

      return campos
        .map((campo, i) => {
          if (indicesMonetarios.indexOf(i) !== -1) {
            return this.formatarMoeda(campo, usarVirgulaDecimal);
          }
          if (indicesData.indexOf(i) !== -1) {
            return this.formatarData(campo);
          }
          if (indicesNotaFiscal.indexOf(i) !== -1) {
            return this.formatarNotaFiscal(campo);
          }
          return campo;
        })
        .join(delimitador);
    })
    .join('\n');

  let csv = '\uFEFF' + csvLimpo;
  let blob: any = new Blob([csv], { type: 'text/plain; charset=utf-8' });
  fileSaver.saveAs(blob, prefixoArquivo + new Date().getTime() + '.csv');
  this.carregando = false;
}

  // Converte valor numerico cru (ex.: "1234.5") em numero somavel.
  // Mantem decimal com virgula quando o CSV usa ';' (Excel pt-BR).
  formatarMoeda(valor: string, usarVirgulaDecimal: boolean): string {
    if (!valor || valor.trim() === '') { return ''; }
    const numero = Number(valor.trim().replace(',', '.'));
    if (isNaN(numero)) { return valor; }
    const formatado = numero.toFixed(2);
    return usarVirgulaDecimal ? formatado.replace('.', ',') : formatado;
  }

  // Remove o ".0" que vem no numero da NF (ex.: "12345.0" -> "12345").
  formatarNotaFiscal(valor: string): string {
    if (!valor || valor.trim() === '') { return ''; }
    const numero = Number(valor.trim().replace(',', '.'));
    if (isNaN(numero)) { return valor; }
    return String(Math.trunc(numero));
  }

  // Converte data crua do banco (ex.: "2026-06-09") em "09/06/2026".
  formatarData(valor: string): string {
    if (!valor || valor.trim() === '') { return ''; }
    const data = moment(valor.trim(), ['YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss', moment.ISO_8601], false);
    return data.isValid() ? data.format('DD/MM/YYYY') : valor;
  }

  exportOneVoiceCsv(): void {
    let start = moment(this.data_inicial).format("YYYY-MM-DD");
    let end = moment(this.data_final).format("YYYY-MM-DD");

    this.carregando = true
    this.service.downloadCsvOneVoice(start, end, this.filtros.dealer, this.filtros.regiao, this.filtros.grupo_economico, this.filtros.mercado)
      .subscribe(res => {

        let blob: any = new Blob([res], { type: 'text/plain; charset=utf-8' });
        let dataAtual = moment(new Date()).format("YYYYMMDD");

        fileSaver.saveAs(blob, dataAtual + '_BR.csv');
        this.carregando = false
      }, error => console.log('Error downloading the file -> ', error));

    this.display = false
  }
}
